module.exports = __webpack_public_path__ + "static/img/__1600.aceaffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1600.jpg
// module id = gu/C
// module chunks = 0